// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SimpleIntakePhoneModel } from './simpleIntakePhoneModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SimpleIntakePrescriberPhonesModel {
    'fax'?: SimpleIntakePhoneModel | null;
    'main'?: SimpleIntakePhoneModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SimpleIntakePrescriberPhonesModel>> = [
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "SimpleIntakePhoneModel"
        },
        {
            "name":     "main",
            "baseName": "main",
            "type":     "SimpleIntakePhoneModel"
        },
    ];

    static getAttributeTypeMap() {
        return SimpleIntakePrescriberPhonesModel.attributeTypeMap;
    }
}
